import Vue from 'vue';

import { initialState } from './state';
import StoreModuleService from '../StoreModuleService';

// mutations declarations
export const SET_NEW_TEMP_BLOCK = 'SET_NEW_TEMP_BLOCK';
export const SET_TEMP_BLOCK = 'SET_TEMP_BLOCK';
export const DELETE_TEMP_BLOCK = 'DELETE_TEMP_BLOCK';
export const UPDATE_TEMP_BLOCK_PROPERTY = 'UPDATE_TEMP_BLOCK_PROPERTY';
export const NODE_ID_TO_MOVE_LOCATION = 'NODE_ID_TO_MOVE_LOCATION';
export const MARK_MOVE_NODE_STATE = 'MARK_MOVE_NODE_STATE';
export const SET_MOVE_NODE_LOADING = 'SET_MOVE_NODE_LOADING';
export const SET_IS_END_RUN_LOADING = 'SET_IS_END_RUN_LOADING';
export const SET_SHORTCUT_COMMAND = 'SET_SHORTCUT_COMMAND';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_NEW_TEMP_BLOCK](state, payload) {
		const { key, value } = payload;
		Vue.set(state.tempBlocks, key, value);
	},
	[DELETE_TEMP_BLOCK](state, payload) {
		const { key } = payload;
		Vue.delete(state.tempBlocks, key);
	},
	[UPDATE_TEMP_BLOCK_PROPERTY](state, payload) {
		const { id, key, value } = payload;
		Vue.set(state.tempBlocks[id], key, value);
	},
	[NODE_ID_TO_MOVE_LOCATION](state, payload) {
		Vue.set(state, 'nodeIdToMove', payload);
	},
	[MARK_MOVE_NODE_STATE](state, payload) {
		Vue.set(state, 'moveNodeActive', payload);
	},
	[SET_MOVE_NODE_LOADING](state, value) {
		Vue.set(state, 'moveNodeLoading', value);
	},
	[SET_TEMP_BLOCK](state, tempBlock) {
		Vue.set(state, 'tempBlock', tempBlock);
	},
	[SET_IS_END_RUN_LOADING](state, value) {
		Vue.set(state, 'isEndRunLoading', value);
	},
	[SET_SHORTCUT_COMMAND](state, value) {
		Vue.set(state, 'shortcutCommand', value);
	},
};

export default mutations;
